import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ParkingIcon from '@material-ui/icons/LocalParking';
import CashDeskIcon from '@material-ui/icons/Storefront';
import PhoneIcon from '@material-ui/icons/PhoneAndroid';
import SettingsIcon from '@material-ui/icons/Settings';
import SettingsApplications from '@material-ui/icons/Tune';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import GetAppIcon from '@material-ui/icons/GetApp';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import BarChart from '@material-ui/icons/BarChart';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import {isComponentVisibleForUser, isComponentEnabledForUser} from 'utils';
import Tooltip from '@material-ui/core/Tooltip';

import logoImgGC from 'assets/logo.gc.png';
import logoImgGP from 'assets/logo-gp-pl.png';
import logoImgSW from 'assets/logo.scrw.png';

import gpIcon from 'assets/icon-gp-pl.png';
import gcIcon from 'assets/gcIcon.png';
import swIcon from 'assets/icon-scrw.png';


import { Button, InputBase, Typography } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SearchIcon from "@material-ui/icons/Search";
import LogoutIcon from '@material-ui/icons/ExitToApp';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
import {logout} from 'redux/actions/auth';

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    height: 70,
    paddingRight: theme.spacing(3), // keep right padding when drawer closed
    color: theme.palette.base[800],
  },
  leftbarIcon: {
    height: '55px',
    width: '230px',
    display: 'flex',
  },
  toolbarIcon: {
    height: 70,
    padding: theme.spacing(3.75, 2, 3.75, 3.75),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...theme.mixins.toolbar,
  },
  menuIcon: {
    width: '30px',
    height: '30px',
    color: theme.palette.primary.main,
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
    backgroundColor: theme.palette.background.drawer,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflow: 'hidden',
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7.5),
    [theme.breakpoints.up('sm')]: {
      // width: theme.spacing(9),
    },
  },
  listOpen: {
    marginLeft: '20px',
    marginRight: '20px'
  },
  listClose: {
    paddingLeft: '5px',
    paddingRight: '4px',
  },
  listBottom: {
    marginTop: 'auto'
  },
  link: {
    textDecoration: 'none',
  },
  listItem: {
    minHeight: 60,
    color: theme.palette.base[600],

    "&.Mui-selected": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    },
    "&.Mui-focusVisible": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    },
    ":hover": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    }

  },
  listItemExpanseLogOut: {
    minHeight: 90,
    color: theme.palette.base[600],
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',

    "&.Mui-selected": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    },
    "&.Mui-focusVisible": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    },
    ":hover": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    }
  },
  listItemExpanse: {
    minHeight: 60,
    color: theme.palette.base[600],

    "&.Mui-selected": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    },
    "&.Mui-focusVisible": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    },
    ":hover": {
      color: "#FFFFFF",
      backgroundColor: "#00D866",
      borderRadius: '15px',
    }
  },
  listItemIcon: {
    minWidth: 40,
    color: 'inherit',
  },
  listItemText: {
    margin: 0,
    fontSize: 18,
    lineHeight: '24px',

    '& > span': {
      whiteSpace: 'normal',
    },
  },
  signOut: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '16px',
    color: '#BABABA',
    backgroundColor: '#F0F0F0',
    textTransform: 'none',
    borderRadius: '8px',

    '&:hover': {
        // backgroundColor: 'transparent',
        color: '#000',
    },
    marginTop: '10px',
  },
  menuButton: {
    marginLeft: '3px'
  },
  username: {
    color: 'black',
    fontWeight: '500'
  }
}));

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        width: '250px',
    },
}))(Tooltip);


function status(posStatutes) {
    return <div dangerouslySetInnerHTML={
        {
            __html: posStatutes && posStatutes.length && posStatutes.length > 0 ? posStatutes[0].message : ""
        }
    }>
    </div>;
}

const PosStatus = ({t, posStatutes}) => {

    const [posId, setPosId] = React.useState(localStorage.getItem('pos_id') || null);


    const getStatusColor = (posStatutes) => {
        if (posStatutes && posStatutes.length && posStatutes.length > 0) {
            if (posStatutes[0].state === 'OK') {
                return '#50A933';
            } else if (posStatutes[0].state === 'INIT') {
                return '#FDBA45';
            } else if (posStatutes[0].state === 'OK') {
                return "#F34734"
            }
        }
        return '#000000';
    }

    const classes = useStyles();

    return (
        <React.Fragment>
            {!posStatutes && <>
                <PrintOutlinedIcon style={{
                    fontSize: 30,
                    color: getStatusColor(posStatutes),
                    paddingRight: '7px'
                }}/>
            </>}
            {posStatutes && <HtmlTooltip title={status(posStatutes)}>
                <PrintOutlinedIcon style={{
                    fontSize: 30,
                    color: getStatusColor(posStatutes),
                    paddingRight: '7px'
                }}/>
            </HtmlTooltip>}
        </React.Fragment>
    );
}

function LeftDrawer(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [selected, setSelected] = useState(1);

  const {
    userUseCases,
    open,
    handleDrawerClose,
    handleDrawerOpen,
    handleFulltextOpen,
    user,
    posStatutes,
  } = props;

  const handleListItemClick = (index) => {
    setSelected(index);
  };

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: classnames(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      {open &&
      <div className={classes.toolbarIcon}>
        {( process.env.REACT_APP_PUBLIC_LOGO === 'gc' || process.env.REACT_APP_PUBLIC_LOGO === 'gp' ) && (<img src={logoImgGC} alt="Green Center" />)}
        {/* {process.env.REACT_APP_PUBLIC_LOGO === 'gp' && (<img className={classes.leftbarIcon}  src={logoImgGP} alt="Green Parking"  />)} */}
        {process.env.REACT_APP_PUBLIC_LOGO === 'scrum' && (<img src={logoImgSW} alt="Scrum ware" />)}
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeftIcon className={classes.menuIcon} />
        </IconButton>
      </div>
      }
      {!open &&
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          className={classnames(classes.menuButton)}
        >

          {(process.env.REACT_APP_PUBLIC_LOGO === 'gc' || process.env.REACT_APP_PUBLIC_LOGO === 'gp') && (<img src={gcIcon} className={classes.menuIcon} alt=""/>)}
          {/* {process.env.REACT_APP_PUBLIC_LOGO === 'gp' && (<img src={gpIcon} className={classes.menuIcon} alt=""/>)} */}
          {process.env.REACT_APP_PUBLIC_LOGO === 'scrum' && (<img src={swIcon} className={classes.menuIcon} alt=""/>)}
        </IconButton>
      }


      <List id='list1' className={open?classes.listOpen:classes.listClose}>
        <ListItem button className={open?classes.listItemExpanse:classes.listItem} onClick={()=>{handleFulltextOpen()}}>
          <ListItemIcon className={classes.listItemIcon}>
            <SearchIcon fontSize="default"/>
          </ListItemIcon>
          <ListItemText primary={t('SEARCH_DOT')} className={classes.listItemText}/>
        </ListItem>

        {isComponentVisibleForUser(UC_MENU_LOCAL_PARKING_DASHBOARD, userUseCases) && (
          <>
          {isComponentEnabledForUser(UC_MENU_LOCAL_PARKING_DASHBOARD, userUseCases) &&
            <Link to={{pathname: `/${process.env.REACT_APP_PATH}/parking`, state: {resetDetailView: true}}} className={classes.link}>
              <ListItem button className={open?classes.listItemExpanse:classes.listItem} selected={selected===1} onClick={() => handleListItemClick(1)}>
                <ListItemIcon className={classes.listItemIcon}>
                  <ParkingIcon />
                </ListItemIcon>
                <ListItemText primary={t('PARKING_DASHBOARD')} className={classes.listItemText} />
              </ListItem>
            </Link>
          }
          {!isComponentEnabledForUser(UC_MENU_LOCAL_PARKING_DASHBOARD, userUseCases) &&
            <ListItem button className={open?classes.listItemExpanse:classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <ParkingIcon />
              </ListItemIcon>
              <ListItemText primary={t('PARKING_DASHBOARD')} className={classes.listItemText} />
            </ListItem>
          }
          </>
        )}

        {isComponentVisibleForUser(UC_MENU_MANAGEMENT_DASHBOARD, userUseCases) && (
          <>
          {isComponentEnabledForUser(UC_MENU_MANAGEMENT_DASHBOARD, userUseCases) &&
            <Link to={`/${process.env.REACT_APP_PATH}/management`} className={classes.link} >
              <ListItem button className={open?classes.listItemExpanse:classes.listItem} selected={selected===2} onClick={() => handleListItemClick(2)}>
                <ListItemIcon className={classes.listItemIcon}>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary={t('MANAGEMENT_DASHBOARD')} className={classes.listItemText} />
              </ListItem>
            </Link>
          }
          {!isComponentEnabledForUser(UC_MENU_MANAGEMENT_DASHBOARD, userUseCases) &&
            <ListItem button className={open?classes.listItemExpanse:classes.listItem} >
              <ListItemIcon className={classes.listItemIcon}>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary={t('MANAGEMENT_DASHBOARD')} className={classes.listItemText} />
            </ListItem>
          }

          </>
        )}

        {isComponentVisibleForUser(UC_MENU_ACCESS, userUseCases) && (
          <>
          {isComponentEnabledForUser(UC_MENU_ACCESS, userUseCases) &&
            <Link to={`/${process.env.REACT_APP_PATH}/access`} className={classes.link}>
              <ListItem button className={open?classes.listItemExpanse:classes.listItem} selected={selected===3} onClick={() => handleListItemClick(3)}>
                <ListItemIcon className={classes.listItemIcon}>
                  <CreditCardIcon />
                </ListItemIcon>
                <ListItemText primary={t('ACCESS_DASHBOARD')} className={classes.listItemText} />
              </ListItem>
            </Link>
          }
          {!isComponentEnabledForUser(UC_MENU_ACCESS, userUseCases) &&
            <ListItem button className={open?classes.listItemExpanse:classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <CreditCardIcon />
              </ListItemIcon>
              <ListItemText primary={t('ACCESS_DASHBOARD')} className={classes.listItemText} />
            </ListItem>
          }

          </>
        )}

        {isComponentVisibleForUser(UC_MENU_CASHDESK_DASHBOARD, userUseCases) && (
          <>
          {isComponentEnabledForUser(UC_MENU_CASHDESK_DASHBOARD, userUseCases) &&          
            <Link to={`/${process.env.REACT_APP_PATH}/cashdesk`} className={classes.link}>
              <ListItem button className={open?classes.listItemExpanse:classes.listItem} selected={selected===4} onClick={() => handleListItemClick(4)}>
                <ListItemIcon className={classes.listItemIcon}>
                  <CashDeskIcon />
                </ListItemIcon>
                <ListItemText primary={t('CASHDESK_DASHBOARD')} className={classes.listItemText} />
              </ListItem>
            </Link>
          }
          {!isComponentEnabledForUser(UC_MENU_CASHDESK_DASHBOARD, userUseCases) &&          
            <ListItem button className={open?classes.listItemExpanse:classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <CashDeskIcon />
              </ListItemIcon>
              <ListItemText primary={t('CASHDESK_DASHBOARD')} className={classes.listItemText} />
            </ListItem>
          }
          </>
          )}
        
        {isComponentVisibleForUser(UC_MENU_ADMINISTRATION, userUseCases) && (
          <>
            {isComponentEnabledForUser(UC_MENU_ADMINISTRATION, userUseCases) &&
              <Link to={`/${process.env.REACT_APP_PATH}/administration`} className={classes.link}>
              <ListItem button className={open?classes.listItemExpanse:classes.listItem} selected={selected===5} onClick={() => handleListItemClick(5)}>
                <ListItemIcon className={classes.listItemIcon}>
                  <SettingsApplications />
                </ListItemIcon>
                <ListItemText primary={t('ADMINISTRATION')} className={classes.listItemText} />
              </ListItem>
            </Link>
            }
            {!isComponentEnabledForUser(UC_MENU_ADMINISTRATION, userUseCases) &&
              <ListItem button className={open?classes.listItemExpanse:classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <SettingsApplications />
                </ListItemIcon>
                <ListItemText primary={t('ADMINISTRATION')} className={classes.listItemText} />
              </ListItem>
            }
          </>
        )}
        {isComponentVisibleForUser(UC_MENU_MDM, userUseCases) && (
          <>
          {isComponentEnabledForUser(UC_MENU_MDM, userUseCases) &&
            <Link to={`/${process.env.REACT_APP_PATH}/mobile`} className={classes.link}>
            <ListItem button className={open?classes.listItemExpanse:classes.listItem} selected={selected===6} onClick={() => handleListItemClick(6)}>
              <ListItemIcon className={classes.listItemIcon}>
                <PhoneIcon />
              </ListItemIcon>
              <ListItemText primary={t('MOBILE_DEVICE_MANAGEMENT')} className={classes.listItemText} />
            </ListItem>
            </Link>
          }
          {!isComponentEnabledForUser(UC_MENU_MDM, userUseCases) &&
            <ListItem button className={open?classes.listItemExpanse:classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <PhoneIcon />
              </ListItemIcon>
              <ListItemText primary={t('MOBILE_DEVICE_MANAGEMENT')} className={classes.listItemText} />
            </ListItem>
        }
          </>
          )}
      </List>
      <List className={classes.listBottom+' '+(open?classes.listOpen:classes.listClose)} id='list2'>
        <ListItem className={open?classes.listItemExpanse:classes.listItem}>
          <ListItemIcon className={classes.listItemIcon}>
            <PosStatus t={t} posStatutes={posStatutes}/>
          </ListItemIcon>
          {posStatutes && posStatutes.length && posStatutes.length > 0 &&  
            <ListItemText primary={posStatutes[0].posId} className={classes.listItemText} />
          }
        </ListItem>

        {isComponentVisibleForUser(UC_MENU_REPORTING, userUseCases) && (
          <>
          {isComponentEnabledForUser(UC_MENU_REPORTING, userUseCases) &&
            <Link to={{ pathname: `${process.env.REACT_APP_REPORTING_PATH}` }} className={classes.link} target="_blank">
              <ListItem button className={open?classes.listItemExpanse:classes.listItem} >
                <ListItemIcon className={classes.listItemIcon}>
                  <BarChart />
                </ListItemIcon>
                <ListItemText primary={t('REPORTING')} className={classes.listItemText} />
              </ListItem>
            </Link>
          }
          {!isComponentEnabledForUser(UC_MENU_REPORTING, userUseCases) &&
            <ListItem button className={open?classes.listItemExpanse:classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <BarChart />
              </ListItemIcon>
              <ListItemText primary={t('REPORTING')} className={classes.listItemText} />
            </ListItem>
          }
          </>
        )}
        {isComponentVisibleForUser(UC_MENU_DOWNLOAD, userUseCases) && (
          <>
          {isComponentEnabledForUser(UC_MENU_DOWNLOAD, userUseCases) &&
            <Link to={`/${process.env.REACT_APP_PATH}/download`} className={classes.link}>
              <ListItem button className={open?classes.listItemExpanse:classes.listItem} selected={selected===7} onClick={() => handleListItemClick(7)}>
                <ListItemIcon className={classes.listItemIcon}>
                  <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary={t('DOWNLOAD')} className={classes.listItemText} />
              </ListItem>
            </Link>
          }
          {!isComponentEnabledForUser(UC_MENU_DOWNLOAD, userUseCases) &&
            <ListItem button className={open?classes.listItemExpanse:classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <GetAppIcon />
              </ListItemIcon>
              <ListItemText primary={t('DOWNLOAD')} className={classes.listItemText} />
            </ListItem>
          }
          </>

        )}
        {isComponentVisibleForUser(UC_MENU_ABOUT, userUseCases) && (
          <>
          {isComponentEnabledForUser(UC_MENU_ABOUT, userUseCases) &&
            <Link to={`/${process.env.REACT_APP_PATH}/about`} className={classes.link}>
              <ListItem button className={open?classes.listItemExpanse:classes.listItem} selected={selected===8} onClick={() => handleListItemClick(8)}>
                <ListItemIcon className={classes.listItemIcon}>
                  <MoreVertIcon />
                </ListItemIcon>
                <ListItemText primary={t('ABOUT')} className={classes.listItemText} />
              </ListItem>
            </Link>
          }
          {!isComponentEnabledForUser(UC_MENU_ABOUT, userUseCases) &&
            <ListItem button className={open?classes.listItemExpanse:classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <MoreVertIcon />
              </ListItemIcon>
              <ListItemText primary={t('ABOUT')} className={classes.listItemText} />
            </ListItem>
          }
          </>
        )}

        <ListItem className={open?classes.listItemExpanseLogOut:classes.listItem}>
          {user && (
            <>
                {!open &&
                  <ListItemIcon className={classes.listItemIcon} onClick={props.logout}>
                    <LogoutIcon />
                  </ListItemIcon>
                }
                {open &&
                <>
                <Typography variant="h5" className={classes.username}>
                    { user.lastName &&  user.firstName && `${user.firstName} ${user.lastName}` }
                    { user.lastName &&  !user.firstName && `${user.lastName}` }
                    { !user.lastName && user.username && `${user.username}` }
                </Typography>                  
                <Button
                    color="primary"
                    variant="text"
                    className={classes.signOut}
                    onClick={props.logout}
                >
                    <div style={{marginLeft:'5px'}}>{t('SIGN_OUT')}</div>
                    <LogoutIcon style={{marginLeft: '15px', marginRight: '5px'}}/>
                </Button>
                </>
                }
            </>
          )}          
        </ListItem>
      </List>
    </Drawer>
  );
}

LeftDrawer.propTypes = {
  user: PropTypes.object,
  userUseCases: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

LeftDrawer.defaultProps = {
  user: null
}

const mapStateToProps = (store) => ({
  user: store.authData.user,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  logout
}, dispatch);

const UC_MENU_LOCAL_PARKING_DASHBOARD = 'UC0002';
const UC_MENU_MANAGEMENT_DASHBOARD = 'UC0057';
const UC_MENU_MDM = 'UC0068';
const UC_MENU_DOWNLOAD = 'UC0074';
const UC_MENU_ABOUT = 'UC0076';
const UC_MENU_ADMINISTRATION = 'UC0600';
const UC_MENU_CASHDESK_DASHBOARD = 'UC0402';
const UC_MENU_REPORTING = 'UC0800';
const UC_MENU_ACCESS = 'UC0900';

export default connect(mapStateToProps, mapDispatchToProps)(LeftDrawer);